import { render, staticRenderFns } from "./caseNews.vue?vue&type=template&id=db9e5460&scoped=true"
import script from "./caseNews.vue?vue&type=script&lang=js"
export * from "./caseNews.vue?vue&type=script&lang=js"
import style0 from "./caseNews.vue?vue&type=style&index=0&id=db9e5460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9e5460",
  null
  
)

export default component.exports